import type { StatusTone } from '@/components/common';
import type { ReceiptStatusView } from '@/types/receipt';

/** 확인으로 정해진 상태(조기 마감·확인 불가)인가 — 이때는 날짜 기준 "접수 중"·D-day 를 보이지 않는다(specs/078 FR-006). */
export function isObservedReceipt(
  receipt?: ReceiptStatusView | null,
): receipt is ReceiptStatusView {
  return receipt?.status === 'CLOSED_EARLY' || receipt?.status === 'UNVERIFIABLE';
}

/**
 * 접수 상태 태그 라벨(specs/078) — 관측 상태(조기 마감·확인 불가)면 서버 라벨, 그 외에는 화면의 기존 상태 라벨.
 * 4값 접수 상태(검색 필터)는 조기 마감을 "마감", 확인 불가를 날짜대로 내려주므로 무엇이 확인됐는지는 이 함수로만 구분한다.
 */
export function receiptLabel(fallback: string, receipt?: ReceiptStatusView | null): string {
  return isObservedReceipt(receipt) ? receipt.label : fallback;
}

/** 접수 상태 태그 tone — 관측 상태면 조기 마감 neutral·확인 불가 warning, 그 외 기존 tone. */
export function receiptTone(fallback: StatusTone, receipt?: ReceiptStatusView | null): StatusTone {
  if (!isObservedReceipt(receipt)) return fallback;
  return receipt.status === 'UNVERIFIABLE' ? 'warning' : 'neutral';
}

/** http/https 만 링크로 허용 — 그 외 스킴은 null(프론트 보안 규칙). */
export function safeHttpHref(url?: string | null): string | null {
  return url && /^https?:\/\//i.test(url) ? url : null;
}
